import moment from "moment";

// prettier-ignore
const monthMapping = {
  "jan": "01",
  "feb": "02",
  "mar": "03",
  "apr": "04",
  "may": "05",
  "jun": "06",
  "jul": "07",
  "aug": "08",
  "sep": "09",
  "oct": "10",
  "nov": "11",
  "dec": "12",
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec",
  "1": "Jan",
  "2": "Feb",
  "3": "Mar",
  "4": "Apr",
  "5": "May",
  "6": "Jun",
  "7": "Jul",
  "8": "Aug",
  "9": "Sep",
};

export const handleDateformat = (dateData, regionID) => {
  if (dateData) {
    let [month, dayAndYear] = dateData.split(" ");
    return getDateFormat(regionID, "date", month.toLowerCase(), dayAndYear.split(",")[0], dayAndYear.split(",")[1]);
  }
  return "";
};

export const handleDateSearch = (SearchDate) => {
  let date;
  SearchDate === undefined ? (date = "") : (date = new Date(SearchDate));
  // date = new Date(SearchDate);
  let convertedDate = date.toLocaleDateString();
  let splitDate = convertedDate.split("/");
  let finalDate;
  if (splitDate[0].length === 1 && splitDate[1].length === 1) {
    finalDate = "0" + splitDate[0] + "/" + "0" + splitDate[1] + "/" + splitDate[2];
  } else if (splitDate[0].length === 1) {
    finalDate = "0" + splitDate[0] + "/" + splitDate[1] + "/" + splitDate[2];
  } else if (splitDate[1].length === 1) {
    finalDate = splitDate[0] + "/" + "0" + splitDate[1] + "/" + splitDate[2];
  } else {
    finalDate = convertedDate;
  }
  return finalDate;
};

export const dateRangeFormat = (date) => {
  var dateSplit = date.split("-");
  let monthResult = monthMapping[dateSplit[1]];
  var convertedDate = monthResult + " " + dateSplit[2] + "," + dateSplit[0];
  return convertedDate;
};

export const dateConversion = (dateData, dateFormat = "YYYY-MM-DD") => {
  return moment(dateData).format(dateFormat);
};

export const handleDateTimeZone = (dateData) => {
  return dateData.replace(/-/g, "/");
};

export const getDateFormat = (regionID, format = false, month = "", day = "", year = "") => {
  //list of countries
  // "36" -> "Australia"
  // "554" -> "New Zealand"
  // "372" -> "Ireland"
  // "250" -> "France"
  // "276" -> "Germany"
  // "528" -> "Netherlands"
  // "826" -> "United Kingdom"
  // "840" -> "US"
  // "124" -> "Canada"
  //"380" -> "Italy",
  //"616" -> "Poland"
  //"620" -> "Portugal"
  //"724" -> "Spain"

  switch (regionID) {
    case "36":
    case "554":
      return format ? day + "/" + monthMapping[month] + "/" + year : "dd/mm/yyyy";
    case "372":
    case "250":
    case "276":
    case "528":
    case "826":
    case "40":
    case "56":
      return format ? day + "." + monthMapping[month] + "." + year : "dd.mm.yyyy";
    case "840":
    case "124":
      return format ? monthMapping[month] + "/" + day + "/" + year : "mm/dd/yyyy";
    default:
      return format ? monthMapping[month] + "/" + day + "/" + year : "mm/dd/yyyy";
  }
};

export const handleDataConvert = (data, regionID) => {
  let convertedData;
  if (data === null || data === undefined) {
    convertedData = "";
  } else {
    let actualData = data.slice(0, 10);
    convertedData = moment(new Date(handleDateTimeZone(actualData))).format("MM/DD/YYYY");
    handleDateConvertToTimezone(data);
  }
  let [month, day, year] = convertedData.split("/");
  return getDateFormat(regionID, "date", monthMapping[month].toLowerCase(), day, year);
};

export const handleDateConvertToTimezone = (data, regionID) => {
  let convertedData;
  if (data === null || data === undefined) {
    convertedData = "";
  } else {
    let actualData = data.slice(0, 10);
    convertedData = moment(data).format("MM/DD/YYYY, h:mm A");
  }
  let [month, day, year] = convertedData.split("/");
  let monthValue = monthMapping[month] && monthMapping[month].toLowerCase();
  return getDateFormat(regionID, "date", monthValue, day, year);
};

export const formatAppointmentDate = (date, time) => {
  let appointmentDate;
  appointmentDate = moment(date).format("MMMM D, YYYY") + " at " + moment(time, "hh:mm A").format("h:mm A");
  return appointmentDate;
};
